"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationScreenCont = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.VerificationScreenCont = styled_components_1.default.div `
  .whiteBg button {
    padding: 3px;
  }
  .whiteBg button + span {
    padding-top: 3px;
  }
  .validation input:not(:focus) {
    border: 1px solid red !important;
  }
  input {
    width: ${({ theme: { isDesktop } }) => (isDesktop ? "45px" : "42px")};
    height: ${({ theme: { isDesktop } }) => (isDesktop ? "45px" : "42px")};
    padding: 0;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    border: 1px solid #000 !important;
    border-radius: 8px;
    background: #fff;
    background-clip: padding-box;
    :not(:last-child) {
      margin-right: ${({ theme: { isDesktop } }) => isDesktop ? "12px" : "8px"};
    }
    :focus {
      outline: 0;
      box-shadow: 0 0 0 3px rgb(131 192 253/50%);
    }
  }
`;
